import { useMemo } from 'react';
import { useGetList } from 'ra-core';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { useRoleDataScope } from './useRoleDataScope';

export type SalesPersonOption = {
  id: number | string;
  name: string;
  cpf_cnpj?: string | null;
};

type Props = {
  value: string;
  onValueChange: (value: string) => void;
  placeholder?: string;
  allLabel?: string;
  className?: string;
};

export const SalesPersonFilter = ({
  value,
  onValueChange,
  placeholder = 'Filtrar por vendedor',
  allLabel = 'Todos os vendedores',
  className,
}: Props) => {
  const { isSuperAdmin, scopedCrmUserIds } = useRoleDataScope();
  const { data } = useGetList<SalesPersonOption>('users', {
    pagination: { page: 1, perPage: 200 },
    sort: { field: 'name', order: 'ASC' },
    filter: { 'disabled@neq': true },
  });

  const options = useMemo(() => {
    let list = (data ?? []).filter((u) => u.name);
    // Gerente só vê os vendedores do próprio escopo (equipe); super-admin vê todos.
    if (!isSuperAdmin) {
      const allowed = new Set(scopedCrmUserIds.map((id) => Number(id)));
      list = list.filter((u) => allowed.has(Number(u.id)));
    }
    return list.sort((a, b) => a.name.localeCompare(b.name, 'pt-BR'));
  }, [data, isSuperAdmin, scopedCrmUserIds]);

  return (
    <Select value={value} onValueChange={onValueChange}>
      <SelectTrigger className={className}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all">{allLabel}</SelectItem>
        {options.map((user) => (
          <SelectItem key={user.id} value={String(user.id)}>
            {user.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
